import {
  ManagedReceivingPartnerApi as Api,
  SharedApiV2,
} from "@capstone/mock-api";
import { AppointmentApprovalDto } from "mock-api/src/shared-v2-types";
import { getApiDetailsDecorator, getEnumMember } from "src/utils";
import { HelpAssistTicketApprovalStatus } from "../help-assist-enums";

const api = getApiDetailsDecorator<Api.AppointmentApproval>();

export class AppointmentApproval {
  public constructor(args: ClassProperties<AppointmentApproval>) {
    this.status = args.status;
    this.statusChangedBy = args.statusChangedBy;
  }

  @api() public readonly status: HelpAssistTicketApprovalStatus;
  @api() public readonly statusChangedBy: string | null;

  public static deserialize(
    data: Api.AppointmentApproval | AppointmentApprovalDto,
  ): AppointmentApproval {
    return new AppointmentApproval({
      ...deserializeApprovalStatus(data.status),
      statusChangedBy: data.statusChangedBy,
    });
  }

  public static deserializeList(
    data: readonly Api.AppointmentApproval[],
  ): AppointmentApproval[] {
    return data.map((approval) => AppointmentApproval.deserialize(approval));
  }
}

export function deserializeApprovalStatus(
  status:
    Api.AppointmentApproval["status"] | SharedApiV2.AppointmentApprovalStatus,
): Pick<AppointmentApproval, "status"> {
  return {
    status: getEnumMember(HelpAssistTicketApprovalStatus, status),
  };
}
